import React from 'react'
import { ERCForm } from 'components/form'
import ERCInput from 'components/Input'
import { ERCButton } from 'components/button'
import { ERCText } from 'components/text'
import { Grid, MenuItem, TextField, Typography } from '@mui/material'

const Counsellorform = () => {
  return (
    <div className='mb-[5px]'>
        
        <div>
            <ERCText size='20px' weight='700' lHeight='24px'>Schedule An Appointment</ERCText>
            </div>
      <ERCForm>
      <div className='flex justify-between mt-[10px]'>
                            <div >
                                <ERCInput containerClass='w-[auto]' label='Student Name' name='fullName' placeholder='Enter your full name' height='43px' />
                            </div>
                            <div >
                                <ERCInput containerClass='w-[auto]' label='Phone Number' name='phoneNumber' placeholder='Enter your phone number' height='43px'/>
                            </div>
                        </div>
                        <div className='flex justify-between mt-[10px]'>
                            <div >
                                <ERCInput containerClass='w-[auto]' label='Email' name='email' placeholder='Enter your email address' height='43px'/>
                            </div>
                            <div >
                                <ERCInput containerClass='w-[auto]' label='Name of School' name='school' placeholder='Enter your school name' height='43px'/>
                            </div>
                        </div>
                        <div className='flex gap-[70px] mt-[10px]'>
                            <div style={{  width: "44%", }} >
                                <ERCInput containerClass='!w-[255px]'  type="select" label='Name of District' name='district' placeholder='Select your district' selectClass="h-[43px] pt-[5px]"  />
                            </div>

                            <div >
                            <ERCInput containerClass='!w-[255px]'  type="select" label='Type of Counselling' name='gender' placeholder='Select counselling type'  selectClass="h-[43px] pt-[5px]"/>
                            {/* <ERCInput containerClass='!w-[255px]' selectClass="h-[43px] pt-[5px]"  type="select" label='Select Date and Time' name='gender' placeholder='Date'  /> */}
                            </div>
                        </div>
                        <div className='flex justify-between mt-[10px]'>
                            <div >
                                <ERCInput containerClass='!w-[255px]'  type="select" label='Category of Counselling' name='category counselling' placeholder='Counselling category' selectClass="h-[43px] pt-[5px]" />
                            </div>
                            <div >
                            <ERCInput containerClass='!w-[255px]' selectClass="h-[43px] pt-[5px]"  type="select" label='Select Date and Time' name='gender' placeholder='Date'  />
                            </div>
                        </div>
                        <div className='ml-[5px]'>
                            <div className='my-[10px]'>
                            <ERCText size='12.79' weight='600'>Message</ERCText>
                            </div>
                        <textarea rows="3" 
                  cols="70" className="bg-[#fff]-50 text-gray-800 border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FFD600]"></textarea>
                        </div>
                        <div className='flex justify-end mt-[10px]'>
                        <ERCButton height='44px' width='239px' bgcolor='#00844B' color='#FFD600'>
                            Schedule Now
                        </ERCButton>
                        </div>
      </ERCForm>
    </div>
  )
}

export default Counsellorform
